import React from "react";
import { Icon, type IconComponent } from "../Icon.js";
import type { IconProps } from "../types.js";

export const ArrowDownIcon: IconComponent = (props: IconProps) => (
    <Icon {...props}>{"\ue5db"}</Icon>
);
ArrowDownIcon.displayName = "ArrowDownIcon";
